import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { defaultAxiosRequestConfig } from "~/api/apiMethods";
import { AttachmentsDetailsError } from "~/typings/types";
import { clientApi } from "~/utils";

const configRequest = {
  ...defaultAxiosRequestConfig,
  headers: {
    "Content-Type": "multipart/form-data"
  }
};

type Props = {
  passportFiles: File[];
  setPassportError: Dispatch<SetStateAction<AttachmentsDetailsError>>;
  setIsFirstLoadingFile: Dispatch<boolean>;
  urlHelperFile: string;
  setPassportFiles?: Dispatch<SetStateAction<File[]>>;
};

/** Используется если загрузить нужно только несколько файлов */
export const useUploadPassportFile = ({
  passportFiles,
  setPassportError,
  setIsFirstLoadingFile,
  urlHelperFile,
  setPassportFiles
}: Props) => {
  const [isMounted, setIsMounted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [filesId, setFilesId] = useState<number[]>([]);

  const formData = new FormData();

  useEffect(() => {
    if (isMounted) {
      try {
        if (
          !passportFiles.length ||
          !(passportFiles.length && filesId.length < passportFiles.length)
        ) {
          return;
        }

        setIsLoading(true);

        const latestFile = passportFiles[passportFiles.length - 1];
        const removeFailedFile = () => {
          setPassportFiles?.(prev => prev.filter(f => f !== latestFile));
        };
        formData.append("file", latestFile);

        clientApi
          .post(urlHelperFile, formData, configRequest)
          .then(response => {
            const data = response?.data;

            if (data?.success === 0 || !data?.data?.file_id) {
              setPassportError({
                has: 1,
                message: data?.errors?.[0]?.message || data?.error?.[0]?.message || "Не удалось загрузить файл"
              });
              removeFailedFile();
              return;
            }

            const fileId = data.data.file_id;
            setFilesId(prev => [...prev, fileId]);
            setIsFirstLoadingFile(true);
          })
          .catch(error => {
            setPassportError({
              has: 1,
              message: error?.response?.data.error?.[0].message
            });
            removeFailedFile();
          })
          .finally(() => {
            setIsLoading(false);
          });
      } catch (error) {
        console.log("useUploadPassportFile error");
      } finally {
      }
    } else {
      setIsMounted(true);
    }
  }, [passportFiles]);

  return { filesId, setFilesId, isLoading };
};
